<mat-dialog-content>
  <h2>{{ data.title | translate }}</h2>
  <p>
    {{ data.message | translate }}
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <eon-ui-button (click)="onCancel()" class="mx-1" rank="secondary" scheme="{{eonUiScheme}}"
                 text="{{ 'buttons.cancel' | translate}}"></eon-ui-button>
  <eon-ui-button (click)="onConfirm()" class="mx-1" rank="primary" scheme="{{eonUiScheme}}"
                 text="{{'buttons.confirm' | translate}}"></eon-ui-button>
</mat-dialog-actions>
